import { motion } from "framer-motion";
import { useSite } from "../../context/SiteContext";
import { Reveal, Overline } from "../Reveal";
import FieldLines from "../FieldLines";

export default function WhoWeAre() {
    const { site, tx } = useSite();
    const c = site?.content || {};

    return (
        <section id="who-we-are" data-testid="who-section" className="grain relative overflow-hidden bg-[#0A0A0A] px-6 py-32 text-white md:px-12 md:py-48 lg:px-24">
            <FieldLines className="absolute -left-56 top-16 h-[36rem] w-[36rem] opacity-60" />
            <div className="relative grid items-center gap-16 md:grid-cols-12">
                <div className="md:col-span-5">
                    <Overline testId="who-overline">Who we are — 02</Overline>
                    <Reveal>
                        <h2 className="font-display mt-6 text-[clamp(3.5rem,8vw,7.5rem)] leading-[0.85]" data-testid="who-title">
                            {tx(c.who_title1) || "MORE THAN"}
                            <br />
                            <span className="text-[#D60024]">{tx(c.who_title2) || "SPORT."}</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.15}>
                        <p className="mt-10 max-w-md text-base leading-relaxed text-white/70" data-testid="who-text">
                            {tx(c.who_text)}
                        </p>
                    </Reveal>
                </div>
                <div className="md:col-span-7">
                    <div className="relative overflow-hidden" data-testid="who-image-wrap">
                        <motion.img
                            src={c.who_image}
                            alt="Sport editorial"
                            loading="lazy"
                            initial={{ scale: 1.15 }}
                            whileInView={{ scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
                            className="aspect-[4/3] w-full object-cover grayscale"
                        />
                        <motion.div
                            initial={{ scaleX: 1 }}
                            whileInView={{ scaleX: 0 }}
                            viewport={{ once: true, margin: "-120px" }}
                            transition={{ duration: 1.2, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
                            className="absolute inset-0 origin-right bg-[#D60024]"
                            aria-hidden="true"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}
